// Generated by Melange

import * as Buhta_cabinet__Receipt from "./Receipt.js";
import * as Buhta_cabinet__Shift from "./Shift.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (onMaximize) {
    return function (maximizeLog) {
      return function (objectId) {
        return function (objectType) {
          return function (orgId) {
            return function (kkm) {
              switch (objectType) {
                case "kkm_receipt" :
                    return JsxRuntime.jsx(Buhta_cabinet__Receipt.make, {
                                onMaximize: onMaximize,
                                maximizeReceipt: maximizeLog,
                                kkm: kkm,
                                orgId: orgId,
                                id: objectId,
                                onClose: onClose
                              });
                case "kkm_report" :
                    return JsxRuntime.jsx(Buhta_cabinet__Shift.make, {
                                kkm: kkm,
                                maximizeShift: maximizeLog,
                                onMaximize: onMaximize,
                                orgId: orgId,
                                id: objectId,
                                onClose: onClose
                              });
                default:
                  return null;
              }
            };
          };
        };
      };
    };
  };
}

function KkmLog(Props) {
  return Curry._5(make(Props.onClose)(Props.onMaximize), Props.maximizeLog, Props.objectId, Props.objectType, Props.orgId, Props.kkm);
}

const make$1 = KkmLog;

export {
  make$1 as make,
}
/* Buhta_cabinet__Receipt Not a pure module */
